import { render, staticRenderFns } from "./TableMedicineMedicalAction.vue?vue&type=template&id=01c2c664&scoped=true&"
import script from "./TableMedicineMedicalAction.vue?vue&type=script&lang=js&"
export * from "./TableMedicineMedicalAction.vue?vue&type=script&lang=js&"
import style0 from "./TableMedicineMedicalAction.vue?vue&type=style&index=0&id=01c2c664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2c664",
  null
  
)

export default component.exports